import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import vuetify from "@/plugins/vuetify";
import { setLocale } from "@/plugins/i18n";
import { saveTheme } from "@/plugins/theme";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    token: null,
    refreshToken: null,
    module: null,
    initials: null,
    avatar: null,
    // Card 17trt6jbffe: nao lidas de Mensagens (badge do menu).
    messagesUnread: { total: 0, lessons: 0, support: 0 },
  },
  getters: {
    token: ({ token }) => token,
    user: ({ user }) => user,
    refreshToken: ({ refreshToken }) => refreshToken,
    module: ({ module }) => module,
    getName: ({ user }) => user?.name || user?.full_name || "",
    messagesUnread: ({ messagesUnread }) =>
      messagesUnread || { total: 0, lessons: 0, support: 0 },
    notificationsCount: ({ user }) => {
      if (!user || user.notificationsCount == null) {
        return 0;
      }

      return Number(user.notificationsCount) || 0;
    },
  },
  mutations: {
    SET_USER(state, payload) {
      state.user = payload;
      localStorage.setItem("user", payload);
    },
    SET_TOKEN(state, payload) {
      state.token = payload;
      localStorage.setItem("token", payload);
    },
    SET_REFRESH_TOKEN(state, payload) {
      state.token = payload;
      localStorage.setItem("refreshToken", payload);
    },
    SET_MODULE(state, payload) {
      state.module = payload;
    },
    SET_INITIALS(state, payload) {
      state.initials = payload;
      localStorage.setItem("initials", payload);
    },
    setAvatar(state, payload) {
      state.avatar = payload;
    },
    // Contadores vem do COUNT da API (texto): converter aqui.
    SET_MESSAGES_UNREAD(state, payload) {
      state.messagesUnread = {
        total: Number(payload?.total) || 0,
        lessons: Number(payload?.lessons) || 0,
        support: Number(payload?.support) || 0,
      };
    },
    SET_NOTIFICATIONS_COUNT(state, payload) {
      if (!state.user) {
        Vue.set(state, "user", {});
      }

      Vue.set(state.user, "notificationsCount", Number(payload) || 0);
    },
  },
  actions: {
    setSignIn({ dispatch }, payload) {
      // O idioma fica salvo no usuario (padrao portugues): onde ele entrar, a
      // plataforma abre no idioma escolhido da ultima vez.
      setLocale(payload.user?.language || "pt", vuetify.framework);
      // O tema tambem: fica gravado e o Connect aplica ao abrir.
      saveTheme(payload.user?.theme || "light");
      dispatch("setUser", payload.user);
      dispatch("setToken", payload.token);
      dispatch("setRefreshToken", payload.refreshToken);
      dispatch("setModule", payload.module);
      dispatch("setInitials", payload.initials);
    },
    setUser({ commit }, payload) {
      commit("SET_USER", payload);
    },
    setToken({ commit }, payload) {
      commit("SET_TOKEN", payload);
    },
    setRefreshToken({ commit }, payload) {
      commit("SET_REFRESH_TOKEN", payload);
    },
    setModule({ commit }, payload) {
      commit("SET_MODULE", payload);
    },
    getUser() {
      return this.getters.user;
    },
    setInitials({ commit }, payload) {
      commit("SET_INITIALS", payload);
    },
    setAvatar({ commit }, payload) {
      commit("setAvatar", payload);
    },
    setNotificationsCount({ commit }, payload) {
      commit("SET_NOTIFICATIONS_COUNT", payload);
    },
  },
  plugins: [createPersistedState({ key: "session" })],
});
